// extracted by mini-css-extract-plugin
export var button = "newsletter-module--button--venqw";
export var checkboxConsent = "newsletter-module--checkbox-consent--SQija";
export var checkboxSubscription = "newsletter-module--checkbox-subscription--2zP3F";
export var consents = "newsletter-module--consents--8Nicx";
export var form = "newsletter-module--form--gAzfw";
export var rodoNote = "newsletter-module--rodo-note--MTwEc";
export var title = "newsletter-module--title--y5XLG";